import { render, staticRenderFns } from "./rightKefuBtn.vue?vue&type=template&id=07119e18&scoped=true"
import script from "./rightKefuBtn.vue?vue&type=script&lang=js"
export * from "./rightKefuBtn.vue?vue&type=script&lang=js"
import style0 from "./rightKefuBtn.vue?vue&type=style&index=0&id=07119e18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07119e18",
  null
  
)

export default component.exports